/** @format */

import {memo} from 'react';

import {OauthProvider, YalperPlatform} from 'graphql/generated/types';

import {providerIconSrc} from 'helpers/imageHelpers';

import {ICON_SIZE, IconsWrapper} from './SensorAdSystemIcons.styles';

const ICON_ORDER: ReadonlyArray<YalperPlatform & OauthProvider> = [
  'YANDEX',
  'GOOGLE',
  'VKONTAKTE_ADS',
  'VKONTAKTE',
];

const ICON_SRC_SIZE = 20;

export const EMPTY_PLATFORMS: ReadonlyArray<YalperPlatform> = [];

interface SensorAdSystemIconsProps {
  platforms: ReadonlyArray<YalperPlatform>;
}

const SensorAdSystemIconsBase = ({platforms}: SensorAdSystemIconsProps) => {
  const visible = ICON_ORDER.filter(p => platforms.includes(p));

  if (visible.length === 0) return null;

  return (
    <IconsWrapper>
      {visible.map(platform => (
        <img
          key={platform}
          data-testid={`sensor-ad-system-icon-${platform}`}
          alt=''
          aria-hidden
          src={providerIconSrc(platform, ICON_SRC_SIZE)}
          width={ICON_SIZE}
          height={ICON_SIZE}
        />
      ))}
    </IconsWrapper>
  );
};

export const SensorAdSystemIcons = memo(SensorAdSystemIconsBase);
